import * as React from 'react';
import { cn } from '@/lib/utils';

type SpacerProps = React.HTMLAttributes<HTMLDivElement>;

const Spacer = React.forwardRef<HTMLDivElement, SpacerProps>(
  ({ className, ...props }, ref) => {
    return <div className={cn('flex-1', className)} ref={ref} {...props} />;
  }
);

Spacer.displayName = 'Spacer';

export { Spacer };
